/* Initiative bars, the disabled "Apply as plan" and the cost-lane note. Tokens only (ADR-0007). */

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 2px;
}

.item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 4px 12px;
  align-items: center;
  border-top: 1px solid var(--line);
}

.list li:first-child.item {
  border-top: 0;
}

.item .pair {
  border-top: 0;
}

.pair {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1.4fr) auto;
  gap: 10px;
  align-items: center;
  min-height: var(--target-min);
  padding: 5px 0;
  border-top: 1px solid var(--line);
  font-size: var(--t-dense);
  color: var(--ink);
  text-decoration: none;
}

.list li:first-child .pair {
  border-top: 0;
}

.pair:hover .name {
  text-decoration: underline;
}

.pair:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: -2px;
  border-radius: 2px;
}

.name {
  min-width: 0;
  overflow-wrap: anywhere;
}

.bars {
  display: grid;
  gap: 3px;
}

.track {
  display: block;
  height: 8px;
  border-radius: 4px;
  background: var(--panel-3);
  overflow: hidden;
}

/* Expected is modelled, so it is an outline and never a solid bar. */
.expected {
  display: block;
  height: 100%;
  box-sizing: border-box;
  border: 1.5px dashed var(--info);
  border-radius: 4px;
  background: var(--info-w);
}

.achieved {
  display: block;
  height: 100%;
  border-radius: 4px;
  background: var(--ink-2);
}

.figures {
  display: grid;
  text-align: right;
  color: var(--muted);
  font-size: var(--t-min);
}

.key {
  margin: 8px 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  color: var(--muted);
  font-size: var(--t-min);
}

.keyExpected {
  width: 14px;
  height: 8px;
  border: 1.5px dashed var(--info);
  border-radius: 4px;
  background: var(--info-w);
}

.keyAchieved {
  width: 14px;
  height: 8px;
  border-radius: 4px;
  background: var(--ink-2);
}

.note {
  margin: 8px 0 0;
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 1.5;
}

.apply {
  display: grid;
  gap: 6px;
  margin-top: 8px;
  justify-items: start;
}

.disabled {
  min-height: var(--target-min);
  padding: 2px 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel-2);
  color: var(--muted);
  font: inherit;
  font-size: var(--t-dense);
  cursor: not-allowed;
}

@media (width <= 640px) {
  .pair {
    grid-template-columns: minmax(0, 1fr);
  }

  .figures {
    text-align: left;
  }
}
